import { render, staticRenderFns } from "./ChangePerson.vue?vue&type=template&id=d7c3680c&"
import script from "./ChangePerson.vue?vue&type=script&lang=js&"
export * from "./ChangePerson.vue?vue&type=script&lang=js&"
import style0 from "./ChangePerson.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports